/**
 * ItemSummary Dialog
 * *Abstract Class - extend from when you need to display detailed information about a sku within a custom dialog
 * Inheriting class should implement method for render view
 */

import Class from '@core/Class';
import Module from '@core/Module';
import View from '@core/View';
import {formatDate} from '@util/DateUtils';
import ProductCatalogService from '@services/ProductCatalogService';
import {Cart} from '@modules/cart/Cart';
import User from '../User';
import Modal from '@plugins/modal';
import recommendations from '../products/recommendations';
import pathOr from 'ramda/src/pathOr';
import {toProductUrl} from '@util/URLUtils';

const ItemSummaryDialog = (Class.extend( Module )).extend( {

    modalOptions: {
        width: 620,
        position: 'top'
    },

    elements: {
        '.continue-shopping': 'continueButton'
    },

    events: {
        'click a[data-quick-view]': '_handleClick'
    },

    init: function () {
        this.itemSummaryLayoutView = new View( 'cartQuickViewLayout' );
        return this;
    },

    loadModules: function () {
        this.recommendations = recommendations;
        this.modal = Modal.getInstance();

        return Promise.resolve( this.modal, this.recommendations );
    },

    processing: function () {
        this.modal.open( {
            position: this.modalOptions.position,
            width: this.modalOptions.width,
            height: this.modalOptions.width * 0.5625,
            content: '<div class="loading-msg"><p class="msg loading">Getting product</p></div>'
        } );
    },

    _handleClick: async function handler ( e ) {
        e.preventDefault();
        if ( typeof e.currentTarget.getAttribute( 'data-disabled' ) === 'string' ) {
            return;
        }

        const sku = e.currentTarget.getAttribute( 'data-sku' );
        if ( sku ) {
            try {
                const skuData = await this.fetch( sku );
                this.renderDetails( skuData );
            }
            catch ( err ) {
                console.error( err );
                window.location = `/checkout?items=${sku},1`;
            }
        }
    },

    fetch: async function ( itemId ) {
        this.processing();
        return ProductCatalogService.getFullDetail( itemId );
    },

    getItemImageSource: pathOr( '/', ['product', 'images', 0, 'source'] ),

    serializeLineItems: function ( lineItems ) {
        if ( !Array.isArray( lineItems ) ) {
            lineItems = [lineItems];
        }

        return lineItems.map( line => ({
            ...line,
            firstImageSrc: this.getItemImageSource( line ),
            hasPriceRestrictions: line.product.customerPrice === -1,
            isLogged: User.isLogged(),
            productUrl: toProductUrl( {
                path: line.product.url,
                sku: line.product.sku
            } ),
            product: {
                ...line.product,
                estimatedShipDateFormatted: !line.product.inStock ?
                    formatDate( line.product.estimatedShipDate ) || 'unknown' : ''
            }
        }) );
    },

    getQuantitiesFor: function ( skus ) {
        return skus.reduce( function ( accum, sku ) {
            return accum + parseInt( sku.quantity, 10 )
        }, 0 );
    },

    closeDialog: function () {
        this.modal.close();
    }

} );

export default ItemSummaryDialog
